import React, { useEffect, useState } from "react";
import Swal from 'sweetalert2';
import { API_URL } from "./config";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const Ministry = () => {
    const navigate = useNavigate();
    const [ministry, setMinistry] = useState({
        id: "",
        name: "",
        description: "",
        leaders: [],
        joined: false,
        dateJoined: null,
    });

    const memberId = localStorage.getItem("UserID");
    const ministryObj = localStorage.getItem("selectedMinistry");
    const rec = JSON.parse(ministryObj);
    const ministryId = rec.id;

    const handleJoin = async () => {
        try {
            let joinResponse = await fetch(`${API_URL}/ministrymembers/join`, {
                method: "post",
                body: JSON.stringify({
                    MemberID: memberId,
                    MinistryID: ministryId,
                }),
                headers: {
                    "Content-Type": "application/json",
                },
            });

            let approveResJson = await joinResponse.json();
            console.log(approveResJson);
            Swal.fire({ text: "Request to submitted!" });
            navigate(`/home`);
            // loadData();
        } catch {
            Swal.fire({ text: "Error sending request, check your network connection", icon: "error" });
        }
    };

    const handleLeave = async () => {
        try {
            let joinResponse = await fetch(
                `${API_URL}/ministrymembers/reqleave/${memberId}/${ministryId}`,
                {
                    method: "put",
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            let approveResJson = await joinResponse.json();
            console.log(approveResJson);
            navigate(`/home`);
        } catch {
            Swal.fire({ text: "Request to leave sent!", icon: "success" });
        }
    };

    const loadData = async () => {
        try {
            const data = localStorage.getItem("selectedMinistry");
            if (data) {
                const parsed = JSON.parse(data);
                console.log(parsed);
                setMinistry({
                    ...parsed,
                });
            }
        } catch (error) {
            console.error("Loading error:", error);
        }
    };

    useEffect(() => {
        loadData();
    }, []);

    const handleProfile = () => {
        navigate(`/ministry-profile`);
    }

    return (
        <div style={{ padding: '18px', marginBottom: '60px', backgroundColor: '#fff', minHeight: '100vh' }}>
            {/* Header with Back Button */}
            <div style={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                marginBottom: '15px',
                position: 'relative'
            }}>
                <button
                    onClick={() => navigate(-1)}
                    style={{
                        backgroundColor: 'transparent',
                        border: 'none',
                        cursor: 'pointer',
                        padding: '8px',
                        borderRadius: '50%',
                        marginRight: '24px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        transition: 'background-color 0.2s ease',
                        ':hover': {
                            backgroundColor: '#f0f2f5'
                        }
                    }}
                >
                    <ArrowBackIcon style={{ color: '#1a6363', fontSize: '28px' }} />
                </button>
                <h4 style={{
                    flex: 1,
                    textAlign: 'center',
                    fontSize: '19px',
                    color: '#1a6363',
                    fontWeight: '600',
                    margin: 0,
                    paddingRight: '52px'
                }}>
                    Ministry Details
                </h4>
            </div>

            {/* Ministry Content */}
            <div style={{
                border: '1px solid #1a6363',
                borderRadius: '10px',
                padding: '15px',
                margin: '10px auto',
                maxWidth: '500px',
                backgroundColor: '#f9f9f9',
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            }}>
                <h5 style={{ margin: '0', fontSize: '16px', color: '#ffffff', backgroundColor: '#1a6363', padding: '10px', borderRadius: '5px' }}>
                    {ministry.name}
                </h5>
                <p style={{ margin: '5px 0', fontSize: '14px', color: '#555' }}>
                    {ministry.description}
                </p>
                <p style={{
                    margin: 0,
                    fontSize: "16px",
                    marginBottom: "16px",
                    color: "#1a6363",
                    fontWeight: 500,
                    textDecoration: "underline"
                }}>
                    Leader(s):
                </p>

                {ministry.leaders?.map((item) => (
                    <div key={item.leaderID} style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        borderBottomWidth: 1,
                        borderBottomColor: "#1a6363",
                        marginBottom: "16px",
                    }}>
                        <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                            <span style={{
                                fontFamily: "Arial, sans-serif",
                                fontSize: "16px",
                                color: "#1a6363",
                                fontWeight: 500
                            }}>
                                {item.admin}
                            </span>
                        </div>
                        <span style={{
                            fontFamily: "Arial, sans-serif",
                            fontSize: "14px",
                            color: "#555",
                            marginTop: "4px"
                        }}>
                            Tel: {item.adminphone}
                        </span>
                    </div>
                ))}
                <button
                    onClick={handleProfile}
                    style={{
                        backgroundColor: '#1a6363',
                        color: '#ffffff',
                        border: 'none',
                        borderRadius: '5px',
                        padding: '10px 20px',
                        cursor: 'pointer',
                        width: '100%',
                        marginTop: 15
                    }}>
                    Ministry Profile
                </button>

                {ministry.joined ? (
                    <button onClick={handleLeave} style={{
                        backgroundColor: '#ff4d4d',
                        color: '#ffffff',
                        border: 'none',
                        borderRadius: '5px',
                        padding: '10px 20px',
                        cursor: 'pointer',
                        width: '100%',
                        marginTop: 15
                    }}>
                        Request to Leave
                    </button>
                ) : ministry.pendingJoin ? (
                    <button style={{
                        backgroundColor: '#1a6363',
                        color: '#ffffff',
                        border: 'none',
                        borderRadius: '5px',
                        padding: '10px 20px',
                        cursor: 'pointer',
                        width: '100%',
                        marginTop: 15
                    }}>
                        Request pending
                    </button>
                ) : ministry.PendingLeave ? (
                    <button style={{
                        backgroundColor: '#1a6363',
                        color: '#ffffff',
                        border: 'none',
                        borderRadius: '5px',
                        padding: '10px 20px',
                        cursor: 'pointer',
                        width: '100%',
                        marginTop: 15
                    }}>
                        Request pending
                    </button>
                ) : (
                    <button onClick={handleJoin} style={{
                        backgroundColor: '#1a6363',
                        color: '#ffffff',
                        border: 'none',
                        borderRadius: '5px',
                        padding: '10px 20px',
                        cursor: 'pointer',
                        width: '100%',
                        marginTop: 15
                    }}>
                        Request to Join
                    </button>
                )}
            </div>
        </div>
    );
};

export default Ministry;

// import React, { useEffect, useState } from "react";
// import Swal from 'sweetalert2';
// import { API_URL } from "./config";
// import { useNavigate } from "react-router-dom";

// const leads = [
//     {
//         admin: "Sibongile Mabhiza",
//         adminphone: "263773228829"
//     },
//     {
//         admin: "Sibongile Mabhiza",
//         adminphone: "263773228829"
//     },
//     {
//         admin: "Sibongile Mabhiza",
//         adminphone: "263773228829"
//     },
//     {
//         admin: "Sibongile Mabhiza",
//         adminphone: "263773228829"
//     }
// ]

// const Ministry = () => {
//     const navigate = useNavigate();
//     const [ministry, setMinistry] = useState({
//         id: "",
//         name: "",
//         description: "",
//         leaders: [],
//         joined: false,
//         dateJoined: null,
//     });

//     const memberId = localStorage.getItem("UserID");
//     const ministryObj = localStorage.getItem("selectedMinistry");
//     const rec = JSON.parse(ministryObj);
//     const ministryId = rec.id;

//     // Join/Leave handlers remain unchanged
//     const handleJoin = async () => {
//         try {
//             let joinResponse = await fetch(`${API_URL}/ministrymembers/join`, {
//                 method: "post",
//                 body: JSON.stringify({
//                     MemberID: memberId,
//                     MinistryID: ministryId,
//                 }),
//                 headers: {
//                     "Content-Type": "application/json",
//                 },
//             });

//             let approveResJson = await joinResponse.json();
//             console.log(approveResJson);
//             Swal.fire({ text: "Request to join sent!", icon: "success" });
//             navigate(`/home`);
//         } catch {
//             Swal.fire({ text: "Error sending request, check your network connection", icon: "error" });
//         }
//     };


//     const handleLeave = async () => {
//         try {
//             let joinResponse = await fetch(
//                 `${API_URL}/ministrymembers/reqleave/${memberId}/${ministryId}`,
//                 {
//                     method: "put",
//                     headers: {
//                         "Content-Type": "application/json",
//                     },
//                 }
//             );

//             let approveResJson = await joinResponse.json();
//             console.log(approveResJson);
//             navigate(`/home`);
//             // setMinistry(prev => ({
//             //     ...prev,
//             //     PendingLeave: true,
//             //     joined: false,
//             //     dateJoined: null,
//             // }));
//         } catch {
//             Swal.fire({ text: "Request to leave sent!", icon: "success" });

//         }

//     };

//     useEffect(() => {
//         const loadData = async () => {
//             try {
//                 const data = localStorage.getItem("selectedMinistry");
//                 if (data) {
//                     const parsed = JSON.parse(data);
//                     console.log(parsed);
//                     setMinistry({
//                         ...parsed,
//                         // leaders: parsed.leaders || [],
//                     });
//                 }
//             } catch (error) {
//                 console.error("Loading error:", error);
//             }
//         };
//         loadData();
//     }, []);

//     return (
//         <div style={{ paddingInline: '10px', marginBottom: "60px"}}>
//             <h4 style={{ textAlign: 'center', fontSize: '17px', color: '#1a6363' }}>
//                 Ministry Details
//             </h4>
//             <div style={{
//                 border: '1px solid #1a6363',
//                 borderRadius: '10px',
//                 padding: '15px',
//                 margin: '10px auto',
//                 maxWidth: '500px',
//                 backgroundColor: '#f9f9f9',
//                 boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
//             }}>
//                 {/* Ministry Info Section */}
//                 <h5 style={{ margin: '0', fontSize: '16px', color: '#ffffff', backgroundColor: '#1a6363', padding: '10px', borderRadius: '5px' }}>
//                     {ministry.name}
//                 </h5>
//                 <p style={{ margin: '5px 0', fontSize: '14px', color: '#555' }}>
//                     {ministry.description}
//                 </p>
//                 <p style={{
//                     margin: 0,
//                     fontSize: "16px",
//                     marginBottom: "16px",
//                     color: "#1a6363",
//                     fontWeight: 500,
//                     textDecoration: "underline"
//                 }}>
//                     Leader(s):
//                 </p>

//                 {/* Leadership Section Integration */}

//                 {ministry.leaders?.map((item) => (
//                     <div key={item.leaderID} style={{
//                         display: "flex",
//                         flexDirection: "column",
//                         alignItems: "flex-start",
//                         borderBottomWidth: 1,
//                         borderBottomColor: "#1a6363",
//                         marginBottom: "16px",

//                     }}>
//                         <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
//                             <span style={{
//                                 fontFamily: "Arial, sans-serif",
//                                 fontSize: "16px",
//                                 color: "#1a6363",
//                                 fontWeight: 500
//                             }}>
//                                 {item.admin}
//                             </span>

//                         </div>

//                         <span style={{
//                             fontFamily: "Arial, sans-serif",
//                             fontSize: "14px",
//                             color: "#555",
//                             marginTop: "4px"
//                         }}>
//                             Tel: {item.adminphone}
//                         </span>
//                     </div>
//                 ))}


//                 {/* Join/Leave Button */}
//                 {ministry.joined ? (
//                     <>
//                         <button onClick={handleLeave} style={{
//                             backgroundColor: '#ff4d4d',
//                             color: '#ffffff',
//                             border: 'none',
//                             borderRadius: '5px',
//                             padding: '10px 20px',
//                             cursor: 'pointer',
//                             width: '100%',
//                             marginTop: 15
//                         }}>
//                             Request to Leave
//                         </button>
//                     </>
//                 ) : ministry.pendingJoin ? (
//                     <button style={{
//                         backgroundColor: '#1a6363',
//                         color: '#ffffff',
//                         border: 'none',
//                         borderRadius: '5px',
//                         padding: '10px 20px',
//                         cursor: 'pointer',
//                         width: '100%',
//                         marginTop: 15
//                     }}>
//                         Request pending
//                     </button>
//                 ) : ministry.PendingLeave ? (
//                     <button style={{
//                         backgroundColor: '#1a6363',
//                         color: '#ffffff',
//                         border: 'none',
//                         borderRadius: '5px',
//                         padding: '10px 20px',
//                         cursor: 'pointer',
//                         width: '100%',
//                         marginTop: 15
//                     }}>
//                         Request pending
//                     </button>
//                 ) : (
//                     <button onClick={handleJoin} style={{
//                         backgroundColor: '#1a6363',
//                         color: '#ffffff',
//                         border: 'none',
//                         borderRadius: '5px',
//                         padding: '10px 20px',
//                         cursor: 'pointer',
//                         width: '100%',
//                         marginTop: 15
//                     }}>
//                         Request to Join
//                     </button>
//                 )}
//             </div>
//         </div>
//     );
// };

// export default Ministry;